<template>
  <!-- <CaseSchiller /> -->
  <InitialEstimatedRate />
</template>

<script>
// import CaseSchiller from './CaseSchiller.vue';
import InitialEstimatedRate from './InitialEstimatedRate.vue';

export default { components: { InitialEstimatedRate } };
</script>

<style scoped></style>
